import {
    BannerCategory,
    BannerDirectus,
} from '@superbet-group/web.types';

export function filterValidBanners(
    banners: BannerDirectus[],
    category: BannerCategory,
): BannerDirectus[] {
    return banners.filter((banner) =>
        // Validate promotion banners
        (
            category === BannerCategory.Promotions
            && isValidPromotionsLink(banner.link)
        )
        // Do not filter out other categories
        || category !== BannerCategory.Promotions,
    );
}

function isValidPromotionsLink(link: string): boolean {
    const isBetslipLink = /^\/?betslip\?/.test(link); // link starts with 'betslip?' or '/betslip?'
    const containsModeAppend = link.includes('mode=append');

    if (!isBetslipLink || !containsModeAppend) {
        return true;
    }

    const bets = link.match(/bets\[\]=([^&]+)/g);
    if (!bets) {
        return false;
    }

    return bets.every((bet) => {
        const betsArray = bet.split(',');
        const oddUuid = betsArray[4];

        return betsArray.length >= 5 && oddUuid !== undefined;
    });
}
